import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import StudentVerification from "../../components/User/StudentVerification";

export default withRouter(connect()(StudentVerification));
